import { render, staticRenderFns } from "./u-btn-text-pill.vue?vue&type=template&id=04b068f3&scoped=true&"
import script from "./u-btn-text-pill.vue?vue&type=script&lang=js&"
export * from "./u-btn-text-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b068f3",
  null
  
)

export default component.exports